/* @flow */
import { ReduceStore } from 'flux/utils';

import { ActionTypes } from 'constants/SettingConstants';
import { dispatcher } from 'lib/Dispatcher';

class SettingsStore extends ReduceStore {
  getInitialState() {
    return {
      settings: null,
    };
  }

  isLoaded() {
    return this.getState().settings !== null;
  }

  getSetting(...names) {
    if (!this.isLoaded()) {
      return null;
    }

    let setting = this.getSettings();
    for (const name of names) {
      if (name in setting) {
        setting = setting[name];
      } else {
        break;
      }
    }
    return setting;
  }

  getSettings() {
    return this.getState().settings;
  }

  getLanguages() {
    return this.getSetting('languages');
  }

  getPrimaryLanguages() {
    return this.getSetting('languages', 'primary');
  }

  getPusherKey() {
    return this.getSetting('pusher', 'key');
  }

  getMinClassNameLength() {
    return this.getSetting('group', 'class_name', 'length', 'min');
  }

  getComposerActivityRegex() {
    return this.getSetting('composer', 'activity_regex');
  }

  getMinPaymentPerPerson() {
    return this.getSetting('payment', 'amount_per_person', 'min');
  }

  getMaxPaymentPerPerson() {
    return this.getSetting('payment', 'amount_per_person', 'max');
  }

  getChatMembersLimit() {
    return this.getSetting('chats', 'members', 'limit');
  }

  getMaxClassNameLength() {
    return this.getSetting('group', 'class_name', 'length', 'max');
  }

  getMinClassCodeLength() {
    return this.getSetting('group', 'name', 'length', 'min');
  }

  getMaxClassCodeLength() {
    return this.getSetting('group', 'name', 'length', 'max');
  }

  getMessagesTiming() {
    return this.getSetting('messages', 'timing');
  }

  getMinimumOrgQueryLength() {
    return this.getSetting('organizations', 'minimum_name_query_length');
  }

  getStripeKey() {
    return this.getSetting('payment', 'stripe', 'publishable_key');
  }

  getGradeLevelForCode(code: string) {
    const grades = this.getSetting('grades');
    return grades && grades.find(g => g.code === code);
  }

  reduce(state, action) {
    switch (action.type) {
      case ActionTypes.LOAD_SETTINGS:
        return { settings: action.settings };
      default:
        return state;
    }
  }
}

export default new SettingsStore(dispatcher);



// WEBPACK FOOTER //
// ./src/stores/SettingsStore.js